var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{opacity:0.2;fill:none;stroke:currentColor;stroke-width:5.000000e-02;stroke-miterlimit:10;} .st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4,10.8c-0.3-0.3-0.7-0.3-1.1-0.1C19.9,10.9,19.5,11,19,11c-1.7,0-3-1.3-3-3c0-0.9,0.4-1.7,1-2.2c0.3-0.3,0.4-0.6,0.3-1 c-0.1-0.4-0.4-0.6-0.8-0.7c-0.2,0-0.3,0-0.5,0c-3,0-5.4,2.2-5.9,5c-1.9,0.2-3.4,1.6-3.8,3.6H5.4c-1.3,0-2.6,0.8-3.1,2.2 C2.1,15.2,2,15.7,2,16.2v0.1c0,2,1.5,3.7,3.4,3.7h10.2c1.9,0,3.4-1.7,3.4-3.7v-0.1c0-0.3,0-0.6-0.1-0.9c1.3-0.7,2.3-1.9,2.8-3.3 C21.8,11.5,21.7,11.1,21.4,10.8z M14.3,6.4C14.1,6.9,14,7.4,14,8c0,2.6,2.1,4.8,4.7,5c-0.2,0.2-0.5,0.4-0.8,0.5c0,0-0.1,0-0.1-0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.1-0.5-0.2c-0.1,0-0.1,0-0.2-0.1 c-0.2-0.1-0.5-0.1-0.7-0.1h-0.9c-0.3-1.2-1-2.3-2-2.9c-0.1-0.1-0.3-0.2-0.5-0.3c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1 C12.3,8,13.1,6.9,14.3,6.4z M17,16.3c0,0.9-0.6,1.7-1.4,1.7H5.4C4.6,18,4,17.2,4,16.3v-0.1c0-0.2,0-0.5,0.1-0.7 c0.2-0.6,0.7-0.9,1.3-0.9h1.8c0.6,0,1-0.4,1-1c0-1.4,1-2.6,2.3-2.6c0.1,0,0.2,0,0.4,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.4,0.1 c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.2,0.1c0.7,0.5,1.2,1.3,1.2,2.3c0,0.6,0.4,1,1,1h1.8c0.4,0,0.8,0.2,1.1,0.6c0,0,0,0.1,0.1,0.1 c0.2,0.3,0.3,0.6,0.3,0.9V16.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.a273d1492f3e5cd4d6c56a73b648d90b.svg";
export { ForwardRef as ReactComponent };